import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'uppercaseAll',
})
export class uppercaseAll implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    return value.toUpperCase();
  }
}
